import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RequestFormComponent } from './request-form/request-form.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { HomeComponent } from './home/home.component';
import { TccAdminComponent } from './tcc-admin/tcc-admin.component';
import { AuthGuard } from './auth.guard';
import { TccDetailComponent } from './tcc-detail/tcc-detail.component';
import { CommentComponent } from './comment/comment.component';
import { PaymentHistoryComponent } from './payment-history/payment-history.component';
import { AssessmentHistoryComponent } from './assessment-history/assessment-history.component';
import { FilingHistoryComponent } from './filing-history/filing-history.component';
import { AssignOfficerComponent } from './assign-officer/assign-officer.component';
import { QueryRequestComponent } from './query-request/query-request.component';
import { DownloadTccCertComponent } from './download-tcc-cert/download-tcc-cert.component';
import { TrackingComponent } from './tracking/tracking.component';
import { UploadDocComponent } from './upload-doc/upload-doc.component';
import { TaxpayerDocumentComponent } from './taxpayer-document/taxpayer-document.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { TccReportsComponent } from './tcc-reports/tcc-reports.component';


const routes: Routes = [
  {path:'', redirectTo:'/home', pathMatch: 'full'},
  {path:'home', component: HomeComponent},
  {path: 'requestForm', component: RequestFormComponent},
  {
    path: 'admin',
    component: TccAdminComponent,
    children:[
      {path: 'resetpassword', component: ResetPasswordComponent}
    ],
  
    canActivate: [AuthGuard]
  },
  // {
  //   path: 'logout',
  //   component: LogoutComponent
  // },
  {
    path: 'detail/:tccNo', 
    component:TccDetailComponent,
    children:[
      {path: 'comment', component:CommentComponent},
      {path: 'payment', component:PaymentHistoryComponent},
      {path: 'assessment', component:AssessmentHistoryComponent},
      {path: 'filing', component:FilingHistoryComponent},
      {path: 'assign', component:AssignOfficerComponent},
      {path: 'query', component:QueryRequestComponent},
      {path: 'document', component: TaxpayerDocumentComponent}
     
    ]
  },
  {path: 'login', component: LoginFormComponent},
  {path: 'upload', component: UploadDocComponent},
  {path: 'download', component: DownloadTccCertComponent},
  {path: 'reports', component: TccReportsComponent},
  {path: 'tracking/:tccno', component: TrackingComponent},
  {path: "**", component: PageNotFoundComponent}
 
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
export const routingComponents = [HomeComponent, RequestFormComponent, LoginFormComponent, 
                                  PageNotFoundComponent, TccAdminComponent, TccDetailComponent, CommentComponent,
                                  PaymentHistoryComponent, AssessmentHistoryComponent, FilingHistoryComponent,
                                  AssignOfficerComponent, QueryRequestComponent,
                                  UploadDocComponent, DownloadTccCertComponent,
                                  TaxpayerDocumentComponent,TrackingComponent, ResetPasswordComponent
                                  ]
